/**
 * Created by rhinov15 on 18/07/2017.
 *
 * Generic entity node will be specialised by sub classes
 */

import { Entity } from "@rhinov/savane-js";
import { EntityManager } from "../EntityManager";
import { GameObjectManager } from "../GameObjectManager";

// For debug only
export var DEBUG_ENTITY_COLOR = [
    '#f96400',//Wall
    '#e500f9',//Joinery
    '#fbe800',//Scene
    '#affa00',//ArrangementObject
    '#fbe800',//Floor
    '#affa00',//ArrangementGroup
    '#2100fa',//Room
    '#fbe800',//FunctionalityChip
    '#00f99d',//TechnicalElement
    '#fbe800',//Staircase
    '#fbe800',//Ligth
    '#fbe800',//RenderCamera
    '#affa00',//ArrangementZone
    '#affa00',//ArrangementDecorated deprecated
    '#fbe800',//SketchBlock
    '#fbe800',//Worktop
    '#fbe800',//Light
    '#fbe800',//Sun
];
/**
*
* Graphical node representing an entity from SavaneJS
*
**/

declare var cc: any;

export class 
EntityNode extends cc.DrawNode {
    _isSelected: boolean = false; //TRUE if node is selected by user
    _isHovered: boolean = false; //TRUE if node is hovered by user pointer

    // Node drawing priority (retrieved from Entity manager in the update method)
    _realLocalZorder: number = 0;
    _overall: boolean = false;
    
    savaneEntity: Entity;
    // Dynamic priority order over time
    dynamicZorder: boolean = true;//If false the zorder won't be updated on each frame
    

    constructor(entity: Entity){
        // Call DrawNode ctor
        super();
        //Set name as entity id
        this.setName(entity.id);
        // Store savane entity
        this.savaneEntity = entity;
        // Uncomment this to enter DEBUG mode for node display
        // this.drawCircle(new cc.p(0,0), 10, Math.PI * 2, 100, false, 3, new cc.color(DEBUG_ENTITY_COLOR[this.savaneEntity.entityType]));
        this.scheduleUpdate();
       

        // DEBUG info display close to the entity (object ID) uncomment to activate
        // var label = new cc.LabelTTF("" + this.savaneEntity.id);
        // label.color = new cc.color(255,0,0);
        // this.addChild(label, 1000, 12);
        // if (this.savaneEntity.entityType === SceneConstants.EntityType.Wall)
        // {
        //    label.setPosition(new cc.p(this.savaneEntity.length / 20, 0));
        // }
    }

    // Select node and children
    setSelected(val: boolean) {
        this._isSelected = val;
        //Select children
        for (var i = 0; i < this.childrenCount; i++) {
            if ((this.savaneEntity as any).savaneEntity !== undefined) {
                this.children[i].setSelected(val);
            }
        }
    }

    isSelected(): boolean {
        return this._isSelected;
    }

    // Hover node
    setHovered(val: boolean) {
        this._isHovered = val;
    }

    // Update relative position
    update(dt?: number, skip?: boolean) {
        super.update(dt);
        // Update display priority returned by EntityManager
        var zOrder = EntityManager.getInstance().getLevel(this.savaneEntity);

        // If new z Order and dynamic order activated
        if (zOrder !== this.getLocalZOrder() && this.dynamicZorder) {
            // Assign new node priority
            this.setLocalZOrder(zOrder);
        }

        // Update rotation and position
        if (!skip) {
            this.setPosition(GameObjectManager.convertToCocosCoord(this.savaneEntity.transform.globalPosition));
            this.setRotation(-this.savaneEntity.transform.globalZRotation * 180 / Math.PI);
        }
    }

    // Set display priority
    setLocalZOrder(val: number) {
        super.setLocalZOrder(val);
        if (!this._overall) {
            this._realLocalZorder = val;
        }
    }

    setValidity(_value: boolean) {
    }

    // Class initialisation, nothing special to do for this class
    onEnter() {
        super.onEnter();
    }

    // Class destructor, simply call super class destructor
    onExit() {
        super.onExit();
    }
}
